<template>
  <div>
    <bread-crumb></bread-crumb>
    <div class="contentRepeat">
      <el-tabs
        v-model="activeName"
        type="border-card"
        size="mini"
        @tab-click="handleClick"
      >
        <el-tab-pane label="上传内容" name="riskControl">
          <div class="uploadContent">
            <el-form
              label-position="right"
              label-width="50px"
              :model="formLabelAlign"
              size="mini"
            >
              <el-form-item label="标题" required>
                <el-input
                  v-model="formLabelAlign.title"
                  rows="15"
                  maxlength="50"
                  placeholder="请输入标题"
                ></el-input>
              </el-form-item>
              <el-form-item label="正文" required>
                <el-input
                  type="textarea"
                  v-model="formLabelAlign.desc"
                  maxlength="30000"
                  show-word-limit
                  placeholder="请输入正文"
                ></el-input>
              </el-form-item>
              <el-form-item label="导入">
                <el-upload
                  action="/api"
                  class="upload-demo"
                  :auto-upload="true"
                  :http-request="httpRequest"
                  :before-upload="checkFile"
                  :disabled="flag || requesting"
                  accept=".doc,.docx,.xls,.xlsx"
                  :show-file-list="false"
                >
                  <el-button size="mini" plain :disabled="flag || requesting"
                    >选择文件</el-button
                  >
                  <el-tooltip
                    placement="top-start"
                    width="200"
                    :disabled="fileName.length < 14"
                    trigger="hover"
                    :content="fileName"
                  >
                    <span class="fileNameinput">{{ fileName }}</span>
                  </el-tooltip>
                  <span slot="tip" class="el-upload__tip"
                    >请上传1M内的word、excel文件</span
                  >
                </el-upload>
                <div class="uploadStatus">
                  <span v-if="this.uploadStatus == 'pending'"
                    ><i class="el-icon-loading" />上传中...</span
                  >
                  <span v-if="this.uploadStatus == 'resolve'"
                    ><i class="el-icon-circle-check" />上传成功</span
                  >
                  <span v-if="this.uploadStatus == 'reject'"
                    ><i class="el-icon-circle-close" />上传失败，{{
                      uploadError
                    }}，请重新上传</span
                  >
                </div>
              </el-form-item>
              <el-form-item>
                <!-- 底部按钮 -->
                <div class="finish-btns">
                  <el-button
                    :disabled="requesting || flag"
                    type="primary"
                    size="mini"
                    @click="executeSnippetRiskControl"
                  >
                    <span>立即查重</span>
                  </el-button>
                </div>
              </el-form-item>
              <div class="tips">
                查重为对接第三方维权骑士平台，查重时间约为半小时，输入内容和导入文件二者选一
              </div>
            </el-form>
          </div>
        </el-tab-pane>
        <el-tab-pane label="检测结果" name="contentSnippet">
          <div class="detectionResult">
            <div class="tips Head">
              查重时长约半小时，需要手动刷新链接，才能看见结果
            </div>
            <div class="item-table">
              <el-table
                :data="tableData"
                border
                size="mini"
                style="width: 100%"
                :header-row-style="{ background: '#f2f2f2' }"
              >
                <el-table-column
                  prop="title"
                  label="标题"
                  :show-overflow-tooltip="true"
                >
                  <template slot-scope="scope">
                    <span v-if="scope.row.title">{{ scope.row.title }}</span>
                    <span v-else>{{ scope.row.content.splice(0, 20) }}</span>
                  </template>
                </el-table-column>
                <el-table-column prop="words" label="字数" width="100">
                </el-table-column>
                <el-table-column
                  label="原创度"
                  width="200"
                  :show-overflow-tooltip="true"
                >
                  <template slot-scope="scope">
                    <span
                      v-if="
                        scope.row.contentRiskControlBizDTO['taskCode'] ===
                        '0000'
                      "
                      >{{
                        `${scope.row.contentRiskControlBizDTO["originality"]}%`
                      }}</span
                    >
                    <span
                      v-else-if="
                        scope.row.contentRiskControlBizDTO['taskCode'] ===
                        '3302'
                      "
                      >查重中，请稍等</span
                    >
                    <el-tooltip
                      v-else
                      placement="top-start"
                      width="200"
                      trigger="hover"
                      :content="scope.row.contentRiskControlBizDTO['taskMsg']"
                    >
                      <span class="repeatStyle"
                        >查重错误<i type="Info" class="el-icon-warning-outline"
                      /></span>
                    </el-tooltip>
                  </template>
                </el-table-column>
                <el-table-column
                  prop="createTime"
                  label="提交时间"
                  width="200"
                  :show-overflow-tooltip="true"
                >
                </el-table-column>
                <el-table-column label="操作" align="center" width="200">
                  <template slot-scope="scope">
                    <el-button
                      type="text"
                      size="small"
                      @click="
                        redirectTo(scope.row.contentRiskControlBizDTO.contentId)
                      "
                      v-if="
                        scope.row.contentRiskControlBizDTO['taskCode'] ===
                        '0000'
                      "
                      >查看</el-button
                    >
                    <el-button
                      type="text"
                      size="small"
                      @click="
                        deleteContentSnippetId(scope.row.contentSnippetId)
                      "
                      >删除</el-button
                    >
                  </template>
                </el-table-column>
              </el-table>
              <pagination
                @sizePageChange="paginationChangeProduct"
                :paginationDatas="paginationDataProduct"
              ></pagination>
            </div>
          </div>
        </el-tab-pane>
      </el-tabs>
    </div>
  </div>
</template>

<script>
import breadCrumb from "@/components/breadCrumb";
import pagination from "@/components/pagination";
import {
  healthCmpBizRiskControlFileParse,
  healthCmpBizSaveContentSnippet,
  healthCmpBizExecuteSnippetRiskControl,
  healthCmpBizPageContentSnippet,
  healthCmpBizDeleteContentSnippet,
} from "@/api/man";
export default {
  name: "medicalCenter",
  data() {
    return {
      formLabelAlign: {
        title: "",
        desc: "",
        file: "",
      }, // 表单数据
      file: "",
      requesting: false,
      tableData: [],
      fileName: "文件名称",
      fileBase64: "",
      uploadStatus: "",
      flag: false,
      activeName: "riskControl",
      paginationDataProduct: {
        total: 0,
        currentPage: 1,
        pageSize: 5,
        pageSizes: [5, 10, 20, 30, 50],
      },
      dialogVisible: false,
    };
  },
  components: {
    breadCrumb,
    pagination,
  },
  watch: {
    activeName(newVal, oldVal) {
      this.$router.push({
        query: {
          ...this.$route.query,
          activeName: newVal,
        },
      });
      if (newVal == "contentSnippet") {
        this.healthCmpBizPageContentSnippet(10, 1);
      }
    },
  },
  created() {
    this.$router.push({
      query: {
        ...this.$route.query,
        activeName: this.$route.query.activeName || this.activeName,
      },
    });
    this.activeName = this.$route.query.activeName;
  },
  methods: {
    onSubmit() {
      this.$refs.liveTableRef.queryList();
    },
    checkFile(file) {
      const isWord =
        /(office|application)(.*)(document|sheet|msword|excel)/.test(file.type);
      const isLt1M = file.size / 1024 / 1024 < 1;
      if (!isWord) {
        this.$message.error("上传文件只能是word、excel格式！");
      }
      if (!isLt1M) {
        this.$message.error("上传文件大小不能超过 1MB!");
      }
      let data = window.URL.createObjectURL(new Blob([file]));
      this.fileName = file.name;
      this.file = data;
      return isWord && isLt1M;
    },
    getBase64(file) {
      return new Promise((resolve, reject) => {
        let reader = new FileReader();
        let fileResult = "";
        reader.readAsDataURL(file);
        //开始转
        reader.onload = function () {
          fileResult = reader.result;
        };
        //转 失败
        reader.onerror = function (error) {
          reject(error);
        };
        //转 结束  咱就 resolve 出去
        reader.onloadend = function () {
          resolve(fileResult);
        };
      });
    },
    httpRequest(request) {
      if (this.flag || this.requesting) return;
      this.flag = true;
      this.getBase64(request.file).then((resBase64) => {
        this.uploadStatus = "pending";
        this.fileBase64 = resBase64.split(",")[1]; // 直接拿到base64信息
        this.uploadFile(this.fileBase64);
      });
    },
    onChange() {
      this.formLabelAlign.title = "";
      this.formLabelAlign.desc = "";
    },
    uploadFile(fileBase64) {
      healthCmpBizRiskControlFileParse({
        tenantId: this.$commonJs.getTenantId(),
        fileName: this.fileName,
        fileBase64: fileBase64,
      })
        .then((res) => {
          this.formLabelAlign.title = res.title;
          this.formLabelAlign.desc = res.content;
          this.fileName = res.fileName;
          this.uploadStatus = "resolve";
          this.$message.success("文件上传成功");
          this.flag = false;
        })
        .catch((res) => {
          this.uploadStatus = "reject";
          this.flag = false;
          this.uploadError = res.msg;
          this.$message.error("文件上传失败");
        });
    },
    executeSnippetRiskControl() {
      if (this.flag || this.requesting) return;
      if (this.formLabelAlign.desc == "" || this.formLabelAlign.title == "") {
        this.$message.error("内容不能为空");
        return;
      }
      this.requesting = true;
      healthCmpBizSaveContentSnippet({
        tenantId: this.$commonJs.getTenantId(),
        title: this.formLabelAlign.title,
        content: this.formLabelAlign.desc,
      }).then(async (res) => {
        healthCmpBizExecuteSnippetRiskControl({
          tenantId: this.$commonJs.getTenantId(),
          contentSnippetId: res.contentSnippetId,
        })
          .then((res) => {
            if (res) {
              this.$message.success("操作成功");
              this.onChange();
              this.fileName = "文件名称";
              this.uploadStatus = "";
            }
          })
          .catch((err) => {
            this.$message.info("内容正在对接中", err.msg || err.echo);
            console.log("err", err);
          })
          .finally(() => {
            this.requesting = false;
            this.activeName = "contentSnippet";
          });
      });
    },
    healthCmpBizPageContentSnippet(pageSize, pageNo) {
      healthCmpBizPageContentSnippet({
        tenantId: this.$commonJs.getTenantId(),
        pageSize,
        pageNo,
      })
        .then((res) => {
          const { data, pageSize, pageNo, totalCount } = res;
          this.tableData = data;
          this.paginationDataProduct = {
            ...this.paginationDataProduct,
            pageSize,
            currentPage: pageNo,
            total: totalCount,
          };
        })
        .catch((error) => {
          console.log(2, error);
        });
    },
    handleClick(tab) {
      this.activeName = tab.name;
    },
    deleteContentSnippetId(id) {
      const { pageSize, currentPage } = this.paginationDataProduct;
      this.$confirm("确认删除么?", "提示", {
        confirmButtonText: "确认删除",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        healthCmpBizDeleteContentSnippet({
          tenantId: this.$commonJs.getTenantId(),
          contentSnippetId: id,
        }).then((res) => {
          if (this.tableData.length == 1) {
            this.healthCmpBizPageContentSnippet(pageSize, currentPage - 1);
          } else {
            this.healthCmpBizPageContentSnippet(pageSize, currentPage);
          }
          this.$message({
            type: "success",
            message: "操作成功",
          });
        });
      });
    },
    paginationChangeProduct(val) {
      this.paginationDataProduct = val;
      this.healthCmpBizPageContentSnippet(val.pageSize, val.currentPage);
    },
    redirectTo(val) {
      let routeUrl = this.$router.resolve({
        path: "/contentTool/contentRepeatDetail",
        query: { id: val },
      });
      window.open(routeUrl.href, "_blank");
    },
  },
};
</script>

<style lang="scss" scoped>
@import "../../../../styles/element.scss";
@import "@/styles/article_common.scss";
.contentRepeat {
  :deep(.el-tabs) {
    padding: 0;
  }
  :deep(.el-tabs__header) {
    margin-bottom: 0;
  }
  :deep(.el-tabs--border-card > .el-tabs__header .el-tabs__item.is-active) {
    border: 0;
  }
  :deep(.el-tabs--border-card > .el-tabs__header) {
    border: 0;
  }
  .uploadContent {
    padding-right: 65px;
  }
  .detectionResult {
    padding: 0 15px;
  }
  :deep(.el-tabs .el-tabs__content) {
    height: 73.5vh;
    overflow-y: auto;
  }
  :deep(.el-form-item__content > .el-input.el-input--mini) {
    width: 50%;
  }
  :deep(.el-textarea__inner) {
    resize: none;
    height: 45vh;
  }
  :deep(.el-tabs .el-tabs__header .el-tabs__item) {
    line-height: 40px;
    height: 40px;
  }
  :deep(.el-button--default.is-plain) {
    color: #409eff;
    background: #fff;
    border-color: #b3d8ff;
  }
  :deep(.el-button--primary.is-disabled),
  :deep(.el-button--default.is-plain.is-disabled) {
    background-color: #fff !important;
    border-color: #ebeef5;
    color: #c0c4cc;
  }
  .fileNameinput {
    border: #f1f1f1 2px solid;
    border-radius: 4px;
    margin: 0 10px;
    line-height: 26px;
    font-size: 12px;
    width: 178px;
    display: inline-block;
    text-align: left;
    overflow-x: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
    vertical-align: middle;
    padding-left: 5px;
  }
  .item-table {
    margin-top: 20px;
  }
  :deep(.el-table__row td) {
    padding: 0;
  }
  .tips {
    margin-left: 15px;
    background: url("~_img/bulb.png") no-repeat;
    background-size: 20px 20px;
    padding-left: 34px;
    height: 20px;
    line-height: 20px;
    color: #ff5055;
    &.Head {
      background-size: 30px 30px;
      height: 30px;
      line-height: 30px;
      font-size: 13px;
      font-weight: 600;
      padding-left: 45px;
    }
  }
  .uploadStatus {
    font-size: 12px;
    position: absolute;
    line-height: 1.5;
    color: #606266;
  }
  .repeatStyle i {
    margin-left: 5px;
  }
}
</style>
